var settings = Drupal.settings.globals_variables || {};
var enable_oab_locator_booking_functions = settings.enable_oab_locator_booking_functions || 0;
(function($) {
window.site = site || {};
site.locator = site.locator || {};
site.locator.ui = site.locator.ui || {};
site.locator.data = site.locator.data || {};
site.locator.errors = site.locator.errors || {};

site.locator.map = null; // Google map object
site.locator.dirMap = null; // Google map object
site.locator.markers = []; // Array of google.maps.marker objects, ordered the same way as their corresponding doors in site.locator.resultData.results
site.locator.locationsHtml = []; // Array of HTML snippets for info windows, ordered the same way as their corresponding doors in site.locator.resultData.results
site.locator.resultData = {}; // contains results from doors query.
site.locator.resultData.results = []; // contains ordered results from doors query.
site.locator.infoWindow = null; // google.maps.InfoWindow object
site.locator.queryFields = 'DOOR_ID, DOORNAME, EVENT_NAME, EVENT_START_DATE, EVENT_END_DATE, EVENT_IMAGE, EVENT_FEATURES, EVENT_TIMES, SERVICES, STORE_HOURS, ADDRESS, ADDRESS2, STATE_OR_PROVINCE, CITY, COUNTRY, ZIP_OR_POSTAL, PHONE1';
site.locator.directionsDisplay = null; // google.maps.DirectionsRenderer object
site.locator.queryArgs = {};
site.locator.queryArgs.params = [];
site.locator.markerCounter = 0;
site.locator.maxResults = 26;
site.locator.sortedDoorIds = [];
site.locator.activeLocation = {};
site.locator.activeLocationIndex = null;
site.locator.filtersSet = false;
site.locator.itemsPerPage = 4;
site.locator.ui.inited=false;
site.locator.getDomNodes = function() {
  var $locatorWrapper = $('.store-locator-content');
  site.locator.nodes = {
    locatorWrapper      : $locatorWrapper,
    localSearchForm     : $('.local-search-form', $locatorWrapper),
    stateMenu           : $('select.local-search-form__state', $locatorWrapper),
    cityMenu           : $('select.local-search-form__city', $locatorWrapper),
    cityMenuLocal       : $('select.local-search-form__city', $locatorWrapper),
    cityMenuIntl        : $('select.city-intl', $locatorWrapper),
    countryMenu         : $('select.country', $locatorWrapper),
    zipInput            : $('.local-search-form__zip', $locatorWrapper),
    distanceMenu        : $('select.distance', $locatorWrapper),
    searchBtn           : $('input.search-button', $locatorWrapper),
    filters             : $('.store-name-filters', $locatorWrapper),
    filtersButton       : $('.store-name-filters__header', $locatorWrapper),
    filtersSubmit       : $('.store-name-filters__submit', $locatorWrapper),
    filtersClear        : $('.store-name-filters__clear', $locatorWrapper),
    filtersDropdown     : $('.store-name-filters__dropdown', $locatorWrapper),
    pager               : $('.doors-results__pager', $locatorWrapper),
    pagerPages          : $('.doors-results__pager-pages', $locatorWrapper),
    viewAllLink         : $('.doors-results__pager-view-all', $locatorWrapper),
    mapPanel            : $('.local-search__map-container', $locatorWrapper),
    map                 : $('.local-search__map', $locatorWrapper),
    dirMap              : $('.local-search__dir-map', $locatorWrapper),
    dirForm             : $('.directions-form', $locatorWrapper),
    dirSubmit           : $('.directions-form__submit', $locatorWrapper),
    dirOriginInput      : $('.directions-form__input--a', $locatorWrapper),
    dirDestinationInput : $('.directions-form__input--b', $locatorWrapper),
    dirResults          : $('.directions-form__results', $locatorWrapper),
    dirClosest          : $('.directions-form__closest-store', $locatorWrapper),
    dirModeLinks        : $('.directions-form__transportation-mode-link', $locatorWrapper),
    resultsHeader       : $('.store-results-header', $locatorWrapper),
    storeResults        : $('.store-results', $locatorWrapper),
    locatorErrors       : $('ul.store-locator__error-messages', $locatorWrapper),
    resultsCountNode    : $('.results-count', $locatorWrapper)
  };
};
  var _scrollPageOnError = function(e) {
      var whereIsErrorTag = $('.store-locator--local-search').offset().top;
      if ($(window).scrollTop() > whereIsErrorTag) {
          $('html,body').animate({ scrollTop: whereIsErrorTag }, 400);
      }
  };
/**
 * This function initializes the UI elements of the Store Locator page.
 * It communicates with site.locator.data via events.
 */
site.locator.ui.init = function() {
  site.locator.nodes.locatorWrapper.removeClass('store-locator--loading');
  if (typeof(site.locator.locationData) === 'undefined') {
    return; // no location data!
  }else if($.isEmptyObject(site.locator.locationData)){
	$.getScript( "/locator/store_data.tmpl" )
	  .done(function( script, textStatus ) {
	  	if(!site.locator.ui.inited){
			site.locator.ui.inited=true;
			site.locator.ui.init();
		}
	  });
	return;
  }

  // set the default countries to the values passed by drupal
  site.locator.defaultCountries = $('#local-countries').val();
  var countryArr = site.locator.defaultCountries.split(',');
  site.locator.defaultCountryArr = $.map(countryArr, $.trim);

  /*
   * This function takes a select menu, removes its options, then adds an option with name="Default" and value = ""
   */
  var _clearMenu = function($menu) {
    var $placeholderNode = $('option:first', $menu.first());
    var currentSelect = $placeholderNode.length ? $placeholderNode.text() : site.locator.language.select;

    //menu[0].options.length = 0;
    $menu.empty();
    generic.forms.select.addOption({
      menuNode: $menu,
      label: currentSelect,
      value: ''
    });
    Drupal.ELB.refreshSelectBoxes($menu);
  };

  /*
   * Initializes select menus by adding default option and populating the State menu from JSON data in page
   */
  var _initMenus = function() {
    // insert default options

    var city_list = [];
    $([ site.locator.nodes.stateMenu, site.locator.nodes.cityMenuLocal, site.locator.nodes.countryMenu, site.locator.nodes.cityMenuIntl ]).each(function() {
      _clearMenu($(this));
    });

    for ( var country in site.locator.locationData ) {
      if (site.locator.locationData.hasOwnProperty(country) && country !== '') {

        if ( site.locator.defaultCountries.indexOf(country) !== -1 ) {
          for ( var state in site.locator.locationData[country] ) {
            for ( var city in site.locator.locationData[country][state] ) {
              if (site.locator.locationData[country][state].hasOwnProperty(city) && city !== '' ) {
                city_list.push(city);
              }
            }
          }
        } else {
          generic.forms.select.addOption({
            menuNode: site.locator.nodes.countryMenu,
            value: country
          });
        }
      }
    }
    city_list.sort();
      for(var i=0 ; i < city_list.length ; i++ ){
        generic.forms.select.addOption({
          menuNode: site.locator.nodes.cityMenu,
          value: city_list[i]
        });
		}    
    Drupal.ELB.refreshSelectBoxes(site.locator.nodes.cityMenu.add(site.locator.nodes.countryMenu));
  };

  /*
   * Event handler for onchange event on State menu
   */
  var _stateMenuChangeHandler = function() {
    var state = site.locator.nodes.stateMenu.val();
    var localCities = {};
    for (var i=0; i < site.locator.defaultCountryArr.length; i++) {
      $.extend(localCities, site.locator.locationData[site.locator.defaultCountryArr[i]]);
    }
    var cityMenu = site.locator.nodes.cityMenuLocal;

    if ((typeof localCities[state] == 'undefined') || (state == '')) {
      _clearMenu( cityMenu );
    } else {
      _filterCityMenu( cityMenu, localCities[state] );
    }
  };

  var _countryMenuChangeHandler = function() {
    var country = site.locator.nodes.countryMenu.val();
    var locationData = site.locator.locationData;
    var cityMenu = site.locator.nodes.cityMenuIntl;
    var cityNames = {};

    if (typeof locationData[country] == 'undefined') {
      _clearMenu( cityMenu );
    } else {
      // Flatten the list, just pass cities not grouped by states.
      for ( var state in locationData[country] ) {
        if ( locationData[country].hasOwnProperty(state) ) {
          // if (state == '') {}
          for ( var city in locationData[country][state] ) {
            if ( locationData[country][state].hasOwnProperty(city) ) {
              cityNames[city] = city;
            }
          }
        }
      }
      _filterCityMenu( cityMenu, cityNames );
    }
  };

  /*
   * Reads value from state menu and populates city menu with the appropriate values, based on JSON data in page
   */
  var _filterCityMenu = function( cityMenu, cityData ) {

    _clearMenu(cityMenu);

    var cityNames = [];

    $.each(cityData, function(k,v) {
      cityNames.push(k);
    });

    var normalizingSort = function(a,b) {
      a = a.toLowerCase();
      b = b.toLowerCase();
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    };

    $.each(cityNames.sort(normalizingSort), function(i, cityName) {
      generic.forms.select.addOption({
        menuNode: cityMenu,
        value: cityName
      });
    });
    Drupal.ELB.refreshSelectBoxes(cityMenu);
  };

  /*
   * Event handler for click of Doors search button
   */
  var _searchClickHandler = function(e) {
    e.preventDefault();
    // Have to reset the filters when actually submitting the form, otherwise filters from a
    // previous search will cause serious issues
    site.locator.filtersSet = false;
    $('.store-name-filters__checkbox:not(#store-name-filter-0)', site.locator.nodes.filtersDropdown).attr('checked', false);
    $('.store-name-filters').removeClass('expanded');
    $('.store-locator').removeClass('expanded-filters');
    _submitQuery();
  };

  /*
   * Collects parameters from form input elements, packs them into parameters,
   * then passes them to search query via the "locator:submitSearchQuery" event.
   * @see site.locator.data.submitQuery
   */
  var _submitQuery = function() {
    var data = {};
    var state = site.locator.nodes.stateMenu.val();
    var city = site.locator.nodes.cityMenuLocal.val();// clean this?
    var zip = encodeURIComponent(site.locator.nodes.zipInput.val());

    var country = site.locator.nodes.countryMenu.val();
    var intlCity = site.locator.nodes.cityMenuIntl.val();

    var showStores = [];
    var $checkBoxes = $('.store-name-filters__checkbox:not(#store-name-filter-0)', site.locator.nodes.filtersDropdown);
    $checkBoxes.each(function() {
      if ($(this).attr('checked')) {
        showStores.push($(this).val());
      }
    });
    if (!showStores.length) {
      showStores = 'all';
    }

    var queryArgs = {
      params : [{
        fields : site.locator.queryFields,
        radius : $("#radius").val(),
        region_id : $("#region-id").val(),
        show_stores_list : showStores,
        uom: 'mile'
      }]
    };

    queryArgs.params[0].zip = zip;
    queryArgs.params[0].state = state;
    queryArgs.params[0].city = city;
    queryArgs.params[0].intlCountry = country;
    if(zip){
        queryArgs.params[0].country = $('#local-countries').val();
    }
    queryArgs.params[0].intlCity = intlCity;

    
    var storeList = [];

    // if we have location data, add to request
    var mobileLatitude  = site.locator.currentLocationData ? site.locator.currentLocationData.latitude : null;
    var mobileLongitude = site.locator.currentLocationData ? site.locator.currentLocationData.longitude : null;

    // Only use current location if other fields aren't set.
    var useCurrentLocation = !zip && !state && !city && !country && !intlCity;
    if (site.locator.hasCurrentLocation && (mobileLatitude && mobileLongitude) && useCurrentLocation) {
      queryArgs.params[0].latitude  = mobileLatitude;
      queryArgs.params[0].longitude = mobileLongitude;
    }

    queryArgs.callback = function() {
      site.locator.ui.displayMap();

      site.locator.ui.displayResultsTable();
    };
    site.locator.queryArgs = queryArgs;

    $(document).trigger('locator.submitSearchQuery', [queryArgs]);
  };

  var _initDirectionsForm = function() {
    site.locator.nodes.dirForm.on('submit', function(e) {
      e.preventDefault();
      var args = {
        origin: site.locator.nodes.dirOriginInput.val(),
        destination: site.locator.nodes.dirDestinationInput.val(),
        travelMode: site.locator.nodes.dirModeLinks.filter('.active').attr('data-name')
      };

      $(document).trigger('locator.submitDirectionsQuery', [args]);
    });
  };

  function _transportationModeClickHandler(e) {
    $(this).addClass('active').siblings().removeClass('active');
    // Update directions only if directions form has already been submitted
    if (site.locator.nodes.locatorWrapper.hasClass('store-locator--directions-map')) {
      site.locator.nodes.dirForm.trigger('submit');
    }
    e.preventDefault();
  }

  function _toggleFilters(e) {
    if (typeof e != 'undefined') {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
    site.locator.nodes.filters.toggleClass('expanded');
    site.locator.nodes.locatorWrapper.toggleClass('expanded-filters');
  }

  function _filter(e) {
    if (typeof e != 'undefined') e.preventDefault();
    // Close up filter:
    _toggleFilters();
    // Submit:
    _submitQuery();
  }

  function _clearFilters(e) {
    if (typeof e != 'undefined') e.preventDefault();
    $('.store-name-filters__checkbox', site.locator.nodes.filtersDropdown).attr('checked', false).first().attr('checked', true);
    if (generic.env.isIE8) {
      var storeListItem = '.store-name-filters__inner ul.store-name-filters__list li.store-name-filters__item';
      site.locator.clearSelectedFilters(storeListItem);
    }
  }

  _initMenus();
  _initDirectionsForm();

  site.locator.nodes.stateMenu.on( 'change', _stateMenuChangeHandler );
  site.locator.nodes.countryMenu.on( 'change', _countryMenuChangeHandler );
  site.locator.nodes.localSearchForm.on( 'submit', _searchClickHandler );
  site.locator.nodes.dirModeLinks.on('click', _transportationModeClickHandler);
  site.locator.nodes.filtersButton.on('click', _toggleFilters);
  site.locator.nodes.filtersSubmit.on('click', _filter);
  site.locator.nodes.filtersClear.on('click', _clearFilters);

  $(document).on('locator.submitDirectionsQuery', function(evt, param) {
    site.locator.data.getDirections(param);
  });
  $(document).on('locator.directionsLoaded', function(evt, param) {
    site.locator.ui.displayDirections(param);
  });
};

/*
 * This function fetches the JS template: /templates/locator/location_info.tmpl
 * and uses it to create the info windows that are displayed when clicking on a pointer image on the map.
 */
site.locator.ui.buildLocationHtml = function (args) {
  var doorData = args.locationData;
  var rendered = Mustache.render( $('script[path="/templates/locator/location_info.tmpl"]').html(), args.locationData );
  var $htm = $(rendered),
      $apptBookLink = $htm.find('.store-locator_book-appointment'),
      $apptBookLinkParent = $apptBookLink.closest( "div.location-info");
      abHref = $apptBookLink.attr('href');
  
  if (args.locationData.APPT_BOOK_COUNTER_ID) {
    $apptBookLinkParent.addClass("appt-booking");
    $apptBookLink.attr('href', abHref + '?counter_id=' + args.locationData.APPT_BOOK_COUNTER_ID);
  } else {
    $apptBookLink.remove();
  }
  args.callback($htm[0]);
  
  
  //args.callback(rendered);
};

site.locator.ui.toggleHours = function() {
  $('.door-row.active .door-row__hours', site.locator.nodes.locatorWrapper).toggle();
  $('.store-locator-location-info').toggleClass('show-hours');
  site.locator.infoWindow.redraw_();
};

/*
 * This function builds the table of result data. It loads the JS template: /templates/locator/door_row.tmpl.
 * The site.locator.resultData.results Array must be populated.
 */
site.locator.ui.displayResultsTable = function() {
  var tbody = null;

  var buildRow = function(doorData, idx) {
    doorData.image_path = site.locator.ui.getMarkerImagePath(idx);
    doorData.index_number = idx;
    doorData.precision_distance = parseFloat(doorData.DISTANCE).toFixed(2);
    doorData.CITY_STATEPROV = (doorData.CITY + ', ' + doorData.STATE_OR_PROVINCE + ' ' + doorData.ZIP_OR_POSTAL);
    doorData.ADDRESSURL = (doorData.ADDRESS + ' ' + doorData.ADDRESS2 + ', ' + doorData.CITY_STATEPROV).replace(/ /g,"+");
    doorData.PHONEURL = doorData.PHONE1.replace(/ /g,"-");
    doorData.is_closest = !idx; // If idx is zero it's the closest store
    
    if (isNaN(doorData.precision_distance) ) {
      doorData.precision_distance = 0;
    }

    var rendered = Mustache.render( $('script[path="/templates/locator/door_row.tmpl"]').html(), doorData );

    var $htm = $(rendered),
      $apptBookLink = $htm.find('.store-locator_book-appointment'),
      $apptBookLinkParent = $apptBookLink.closest( "div.door-row__info");
      abHref = $apptBookLink.attr('href');
      console.log($apptBookLinkParent);

    if (doorData.APPT_BOOK_COUNTER_ID) {
      $apptBookLinkParent.addClass("appt-booking");
      $apptBookLink.attr('href', abHref + '?counter_id=' + doorData.APPT_BOOK_COUNTER_ID);
    } else {
      $apptBookLink.remove();
    }

    var $row = tbody.append($htm[0]).find('> div').last();

    $row.on('click', function(e) {
      e.preventDefault();
      if ($(e.target).hasClass('door-row__hours-link')) {
        site.locator.ui.toggleHours();
      } else {
        markerClickCallback.call(site.locator.markers[ $(this).index() ]);
      }
    });
  };

  var rendered = Mustache.render( $('script[path="/templates/locator/doors_table.tmpl"]').html(), {} );
  site.locator.nodes.resultsHeader.show();
  site.locator.nodes.storeResults.html(rendered);
  site.locator.nodes.pager = $('.doors-results__pager', site.locator.nodes.locatorWrapper);
  site.locator.nodes.viewAllLink = $('.doors-results__pager-view-all', site.locator.nodes.locatorWrapper);
  site.locator.nodes.pagerPages = $('.doors-results__pager-pages', site.locator.nodes.locatorWrapper);
  tbody = $( 'div.doors-results__inner', site.locator.nodes.storeResults );

  var j = 0;
  for (var d in site.locator.resultData.results) {
    if (site.locator.resultData.results.hasOwnProperty(d)) {
      buildRow(site.locator.resultData.results[d], j);
      j++;
    }
  }

  var totalResults = j;
  site.locator.ui.renderPager(totalResults);

  if (typeof site.locator.queryArgs.params != 'undefined' && site.locator.queryArgs.params.length) {
    var params = site.locator.queryArgs.params[0];
    var searchCriteria = [];
    var paramKeys = ['state', 'city', 'zip', 'country'];
    var searchQuery = site.locator.language.currentLocation;
    var of = site.locator.language.of;
    var resultsFor;
    var resultsText;

    for (var i=0; i < paramKeys.length; i++) {
      var paramKey = paramKeys[i];
      if (typeof params[paramKey] != 'undefined' && params[paramKey] !== '') {
        searchCriteria.push(params[paramKey]);
      }
    }
    if (searchCriteria.length || typeof params.latitude == 'undefined' || !params.latitude) {
      searchQuery = $.trim(searchCriteria.join(' '));
    }

    // Eg. 1-20 of 20 results for NY New York 11238

    resultsFor = totalResults == 1 ? site.locator.language.resultsCountSingular : site.locator.language.resultsCountPlural;
    resultsText = '1-' + totalResults + ' ' + of + ' ' + totalResults + ' ' + resultsFor + ' ' + searchQuery;

    site.locator.nodes.resultsCountNode.text(resultsText).show();
    omnidata = [searchQuery, totalResults];
	if (typeof tms_page_data != 'undefined' && typeof tms_page_data.tms_page_info != 'undefined'){
		tms_page_data.tms_page_info['STORELOCATOR'] = omnidata;
	}
    jQuery(window).trigger("STORELOCATOR",[omnidata]);
    //console.log("locator triggered",[omnidata]);
  }

  // Render store filters:
  if (!site.locator.filtersSet && j) {
    site.locator.filtersSet = true; // Only render filters the first time
    site.locator.nodes.locatorWrapper.addClass('has-filters');
    var storeNames = [];
    for (var e in site.locator.resultData.results) {
      if (site.locator.resultData.results.hasOwnProperty(e)) {
        storeNames.push( $.trim( site.locator.resultData.results[e].DOORNAME ) );
      }
    }
    storeNames = _.uniq(storeNames).sort();
    storeNames.unshift(site.locator.language.allStores); 
    var renderedFilters = '';
    var template = $('#store-name-filter-template').html();
    for (var h = 0; h < storeNames.length; h++) {
      renderedFilters += Mustache.render( template, { index: h, store_name: storeNames[h] } );
    }
    $('.store-name-filters__list', site.locator.nodes.filters).html(renderedFilters);

    var $checkBoxes = $('.store-name-filters__checkbox', site.locator.nodes.filtersDropdown);
    $checkBoxes.first().attr({
      // disabled: 'disabled',
      checked: true
    });
    if (generic.env.isIE8) {
      $checkBoxes.first().next().addClass('checkedlabel');
      $checkBoxes.filter(':not(#store-name-filter-0)').next().addClass('notcheckedlabel');
    }
    // Clicking all stores always enables it and disables everything else, you
    // can't disable all stores and not have any stores checked.
    $('#store-name-filter-0, label[for=store-name-filter-0]', site.locator.nodes.filtersDropdown).on('click', function(event) {
      $(this).attr('checked', 'checked');
      $checkBoxes.filter(':not(#store-name-filter-0)').attr('checked', false);
    });
    $checkBoxes.filter(':not(#store-name-filter-0)').on('change', function(e) {
      var checkAll = true;
      $checkBoxes.each(function() {
        if ($(this).attr('checked')) {
          checkAll = false;
          return false;
        }
      });
      $checkBoxes.first().attr('checked', checkAll);
    });
  } else if (!site.locator.filtersSet && !j) {
    site.locator.nodes.locatorWrapper.removeClass('has-filters');
  }

  //$('html, body').animate({ scrollTop: site.locator.nodes.resultsHeader.offset().top + 'px' }, 'fast');
};

/*
 * Render the pager.
 */
site.locator.ui.renderPager = function(totalResults) {

  if (totalResults > site.locator.itemsPerPage) {
    var numPages = Math.ceil(totalResults / site.locator.itemsPerPage);
    var numPageLinks = 0;
    var $rows = $('.door-row', site.locator.nodes.locatorWrapper);

    while (numPages > numPageLinks) {
      numPageLinks++;
      site.locator.nodes.pagerPages.append('<li class="doors-results__pager-page-link">' + numPageLinks + '</li>');
    }

    $('.doors-results__pager-page-link', site.locator.nodes.locatorWrapper).on('click', function(e) {
      var index = $(this).index() * site.locator.itemsPerPage;
      $rows.hide().slice( index, index + site.locator.itemsPerPage ).show();
      $(this).addClass('active').siblings().removeClass('active');
      site.locator.nodes.locatorWrapper.removeClass('show-all');

      e.preventDefault();
    });

    site.locator.nodes.viewAllLink.on('click', function() {
      $(this).addClass('active');
      $('.doors-results__pager-page-link', site.locator.nodes.locatorWrapper).removeClass('active');
      site.locator.nodes.locatorWrapper.addClass('show-all');
      $rows.show();
	    $(".doors-results__pager").hide();
    });

    $rows.slice( site.locator.itemsPerPage ).hide();
    $('.doors-results__pager-page-link', site.locator.nodes.locatorWrapper).first().addClass('active');

    site.locator.nodes.pager.show();
  } else {
    site.locator.nodes.pager.hide();
  }
};

/*
 * Convenience funtion that builds the path to custom pointer images.
 * Images should be named map_marker_[capital letter].png and placed in /images/locator.
 * @returns {string} relative path to image, e.g., /images/locator/map-marker-B.png
 */
site.locator.ui.getMarkerImagePath = function(num, active) {
  var ltr = String.fromCharCode('a'.charCodeAt(0) + num);
  if (active) ltr += '_active';

  return generic.env.domain + '/sites/esteelauder/themes/estee_base/img/locator/marker_' + ltr + '.png';
};

function markerClickCallback() {
  // Activate:
  for (var i = 0; i < site.locator.markers.length; i++) {
    site.locator.markers[i].setIcon(site.locator.ui.getMarkerImagePath(i));
  }
  this.setIcon(site.locator.ui.getMarkerImagePath(this.idx, true));
  site.locator.ui.launchInfoWindow(this.idx);

  // Go to page if view all isn't selected
  if (!site.locator.nodes.viewAllLink.hasClass('active')) {
    var page = Math.floor((this.idx) / site.locator.itemsPerPage);
    $('.doors-results__pager-page-link').eq(page).trigger('click');
  }
}

site.locator.data.getDirections = function(args) {
  var directionsService = new google.maps.DirectionsService();
  site.locator.directionsDisplay = new google.maps.DirectionsRenderer({
    // We provide our own markers in site.locator.ui.displayDirections
    suppressMarkers: true
  });

  site.locator.nodes.dirResults.empty();

  site.locator.directionsDisplay.setMap(site.locator.dirMap);
  site.locator.directionsDisplay.setPanel(site.locator.nodes.dirResults.get(0));

  // Default to current location for the origin:
  if (!args.origin && site.locator.hasCurrentLocation) {
    args.origin = new google.maps.LatLng(site.locator.currentLocationData.latitude, site.locator.currentLocationData.longitude);
  }

  directionsService.route(args, function(response, status) {
    $('.dirError').remove();
    if (status == google.maps.DirectionsStatus.OK) {
      $(document).trigger('locator.directionsLoaded', [response]);
    } else if (status == google.maps.DirectionsStatus.NOT_FOUND) {
      // Couldn't find address, we need to show the user an error message
      $('<ul class="error_messages dirError"><li>'+site.locator.errors.dirInvalidAddress+'</li></ul>').insertBefore('.directions-form__results');
    } else if (status == google.maps.DirectionsStatus.ZERO_RESULTS) {
      // No route between locations
      $('<ul class="error_messages dirError"><li>'+site.locator.errors.dirNoRoute+'</li></ul>').insertBefore('.directions-form__results');
    } else {
      // Some other error that prevented us from getting directions.
      $('<ul class="error_messages dirError"><li>'+site.locator.errors.dirUnknownError+'</li></ul>').insertBefore('.directions-form__results');
    }
  });
};

/*
 * Callback function for "locator:directionsLoaded" event.
 * Shows the directions map container, hides the stores map container,
 * passes directions query response to google.maps.DirectionsRenderer object.
 * @param response {Object} response from Google Maps directions query
 */
site.locator.ui.displayDirections = function(response) {
  // Reset store location results:
  site.locator.nodes.locatorErrors.empty();
  site.locator.nodes.locatorWrapper.addClass('store-locator--directions-map');
  site.locator.ui.displayMap(true);
  site.locator.directionsDisplay.setDirections(response);

  // Show the route:
  var route = response.routes[0].legs[0];

  var markerOrigin = new google.maps.Marker({
    position: route.steps[0].start_location,
    map: site.locator.dirMap,
    icon: site.locator.ui.getMarkerImagePath(0, true)
  });

  var markerDestination = new google.maps.Marker({
    position: route.steps[route.steps.length - 1].end_location,
    map: site.locator.dirMap,
    icon: site.locator.ui.getMarkerImagePath(1, true)
  });
};

/*
 * This function encapsulates the various calls to the Google Maps API that render
 * the map of results. It initializes a google.maps.Map object (storing it in site.locator.map),
 * adds markers, and sets up the event handler for clicking on the markers.
 * The site.locator.resultData.results Array must be populated.
 */
site.locator.ui.displayMap = function(directions) {
  var $mapNode = (directions ? site.locator.nodes.dirMap : site.locator.nodes.map);

  var mapOptions = {
    center: new google.maps.LatLng( site.locator.resultData.latitude, site.locator.resultData.longitude ),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: false,
    navigationControl: true,
    mapTypeControl: false,
    scaleControl: true
  };

  if (!directions) {
    mapOptions.zoom = 12;
  }

  var map = new google.maps.Map($mapNode.get(0), mapOptions);

  var location;
  var latLng;
  var markerPath;
  var marker;

  if (directions) {
    site.locator.dirMap = map;
    site.locator.directionsDisplay.setMap(site.locator.dirMap);
  } else {
    site.locator.map = map;
  }

  // Helper function for stores map, kept out here to
  // appease jshint.
  function buildLocationCallback(html) {
    site.locator.locationsHtml[idx] = html;
    // display info window on first location
    if (!idx) {
      markerClickCallback.call(site.locator.markers[ idx ]);
      site.locator.ui.launchInfoWindow(idx);
    }
  }

  function setLocationVars(idx, d) {
    d = d || idx;
    location = site.locator.resultData.results[d];
	location.CITY_STATEPROV = (location.CITY + ', ' + location.STATE_OR_PROVINCE + ' ' + location.ZIP_OR_POSTAL);
    latLng = new google.maps.LatLng(location.LATITUDE, location.LONGITUDE);
    if (!directions) {
      markerPath = site.locator.ui.getMarkerImagePath(idx);
      marker = new google.maps.Marker({
        icon: markerPath,
        map: map,
        position: latLng,
        idx: idx
      });
    }
  }

  // Directions map:
  if (directions) {
    var i = site.locator.activeLocationIndex;
    if (i !== null) {
      var id = 's' + site.locator.sortedDoorIds[i];
      setLocationVars(i, id);
      location.image_path = site.locator.ui.getMarkerImagePath(i);
      map.setCenter(latLng);
    }
  }

   // Stores map:
  else {
    site.locator.nodes.locatorWrapper.removeClass('store-locator--directions-map');
    $('.dirError').remove();
    site.locator.nodes.dirResults.empty();
    var idx = 0;

    for (var d in site.locator.resultData.results) {
      if ( site.locator.resultData.results.hasOwnProperty(d) ) {

        if (idx > site.locator.maxResults) break;

        // place markers on Google Map
        setLocationVars(idx, d);

        var zIndex = site.locator.maxResults - idx;
        marker.setZIndex(zIndex);

        site.locator.markers[idx] = marker;

        // build info window
        site.locator.ui.buildLocationHtml({
          locationData: location,
          callback: buildLocationCallback
        });

        // launch info window on click of marker (on map)
        google.maps.event.addListener( marker, 'click', markerClickCallback );

        // set map center for first location
        if (!idx) {
          site.locator.map.setCenter(latLng);
        }
        idx++;
      }
    }
  }

  google.maps.event.trigger(map,'resize');
};

/*
 * Displays Info Window for a given marker/door.
 * @param i {Number} index of door/marker for which info window should be displayed
 */
site.locator.ui.launchInfoWindow = function(i) {
  if (typeof InfoBubble != 'undefined') {
    if (!site.locator.infoWindow) {
      site.locator.infoWindow = new InfoBubble({
        width: 245,
        height: 'auto',
        borderRadius: 0,
        padding: 0 // Set padding on .location-info instead
      });
    }
  } else {
    // Launch default google maps info window
    site.locator.infoWindow = new google.maps.InfoWindow();
  }

  site.locator.infoWindow.setContent(site.locator.locationsHtml[i]);
  site.locator.infoWindow.open(site.locator.map, site.locator.markers[i]);

  site.locator.markers[i].setZIndex(site.locator.markerCounter + 100);
  site.locator.markerCounter++;

  if (typeof site.locator.infoWindow.hideCloseButton == 'function') {
    site.locator.infoWindow.hideCloseButton();
  }

  // When first launched the info bubble is rendered before the results, hence the timeout.
  setTimeout(function() {
    $('.door-row.active .door-row__marker img').each(function(){
      $(this).attr('src', $(this).attr('src').replace('_active', ''));
    });
    $('.door-row-' + i, site.locator.nodes.locatorWrapper).addClass('active').siblings().removeClass('active');
    $('.door-row.active .door-row__marker img').attr('src', site.locator.ui.getMarkerImagePath(i, true));

    // Append this active door to the directions form
    var $activeDoor = $('.door-row.active', site.locator.nodes.storeResults).clone();
    site.locator.nodes.dirClosest.html($('<div>').append($activeDoor).html());
    $('.door-row__change', site.locator.nodes.dirClosest).on('click', function(event) {
      event.preventDefault();
      // Switch to stores tab:
      $('.local-search__option-stores', site.locator.nodes.locatorWrapper).trigger('click');
    });
  }, 0);

  // This needs to wait til after the "panToView" timeout (200ms) infobubble sets
  setTimeout(function() {
    // Hours link:
    $('.location-info__hours-link', site.locator.nodes.locatorWrapper).on('click', function(e) {
      e.preventDefault();
      site.locator.ui.toggleHours();
    });

    // "Get Directions" link
    $('.location-info__directions-link', site.locator.nodes.map).off('click.getDirections').on('click.getDirections', function(e) {
      e.preventDefault();
      // Switch to directions tab:
      $('.local-search__option-directions', site.locator.nodes.locatorWrapper).trigger('click');
      // Submit directions form:
      site.locator.nodes.dirForm.trigger('submit');
    });
  }, 250);

  // Whenever the info window is changed, also update the directions field
  var location = site.locator.resultData.results['s' + site.locator.sortedDoorIds[i]];
  var locationString = location.ADDRESS;
  site.locator.activeLocation = location;
  site.locator.activeLocationIndex = i;

  if (location.ADDRESS2) locationString += ' ' + location.ADDRESS2;
  locationString += ' ' + location.CITY + ', ' + location.STATE_OR_PROVINCE + ' ' + location.ZIP_OR_POSTAL;

  site.locator.nodes.dirDestinationInput.val(locationString).trigger('blur.formTextInputs');
};

site.locator.util = {};

site.locator.util.fixDate = function(date) {
  if (!date) { return; }

  if( typeof date != 'undefined' ) {
    date = date.split(' ')[0];
  } else {
    date = 'XX-XXX-XXXX';
  }
  var dateParts = date.split('-');
  return dateParts[1] + ' ' + dateParts[0] + ', ' + dateParts[2];
};

site.locator.util.getLocation = function() {
  // unable to get location info
  var error_handler = function() {
    // alert('error handler')
    // site.locator.run();
  };

  // able to get location
  var success_handler = function(position) {
    var lat = position.coords.latitude;
    var lng = position.coords.longitude;
    var latlng = new google.maps.LatLng(lat, lng);

    // This searches latlng and changes the zip code placeholder to "Current
    // Location"

    // site.locator.hasCurrentLocation = true;
    // site.locator.currentLocationData = { latitude: lat, longitude: lng };
    // if current location is found, disable zip
    // var zip = $('.local-search-form__zip')[0];
    // zip.placeholder = site.locator.language.currentLocation;

    // But instead of doing that, get the postal code from latlng using google's
    // geocoder.
    var postalCode;
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({'latLng': latlng}, function(results, status) {
      if (status == google.maps.GeocoderStatus.OK && results[0]) {
        var countries = $.map(results[0].address_components, function (item) {
          if (item.types[0] == 'country') return item.short_name;
        });
        if (!countries.length || countries[0] != 'US') {
          site.locator.getDomNodes();
          generic.showErrors([{ text : site.locator.errors.nonUSZip }], site.locator.nodes.locatorErrors);
          _scrollPageOnError();
        } else {
          // Pull the postal code from the results array:
          var postals = $.map(results[0].address_components, function (item) {
            if (item.types[0] == 'postal_code') return item.short_name;
          });
          if (postals.length) postalCode = postals[0];
        }
      }

      if (!postalCode) {
        error_handler();
        return;
      }
      $('.local-search-form__zip').val(postalCode).addClass('filled-in');

      // site.locator.run();

      site.locator.nodes.localSearchForm.trigger( 'submit' );
    });

    return true;
  };

  if ( window.blackberry && blackberry.location.GPSSupported ) {
    if ( typeof(blackberry.location.setAidMode) == 'undefined' ) {
      error_handler();
      return;
    }

    blackberry.location.setAidMode(2);

    var getCurrentPosition = function(successCallback,errorCallback,options) {
      var bb_blackberryTimeout_id;

      var bb_timeout = function handleBlackBerryLocationTimeout() {
        clearTimeout(bb_blackberryTimeout_id);
        errorCallback();
      };

      bb_blackberryTimeout_id = setTimeout( bb_timeout, 1000 );

      var handleBlackBerryLocation = function() {
        var lat = blackberry.location.latitude;
        var lng = blackberry.location.longitude;
        if (!lat && !lng) {
          errorCallback();
        } else {
          var pos = {};
          pos.coords = {
            latitude: lat,
            longitude: lng
          };

          successCallback(pos);
        }
      };

      blackberry.location.onLocationUpdate(handleBlackBerryLocation);
      blackberry.location.refreshLocation();
    };

    getCurrentPosition(success_handler, error_handler);
  } else {
    if (typeof navigator != 'undefined' && typeof navigator.geolocation != 'undefined') {
      navigator.geolocation.getCurrentPosition(success_handler, error_handler);
    } else {
      error_handler();
    }
  }
};

site.locator.run = function() {
  site.locator.getDomNodes();
  site.locator.ui.init();
};

/*
 * This function handles the query submit event. It parses the data from the event memo
 * and passes it to the fetch method. This method should NOT be called directly by a UI method;
 * rather, the params should be passed as part of the memo to the locator:submitSearchQuery event.
 * @param {function} args.callback a function that gets called after door data is returned
 * @param {Array} args.params an Array that contains a hash of parameters that get
 * passed to the JSON-RPC method.
 * @param {Array} args.params[0].fields The data fields to be returned from the JSON-RPC request
 * @param {number} args.params[0].radius The distance from the origin point inside which stores should be returned.
 * @param {string} args.params[0].zip Postal Code of origin point location
 * @param {string} args.params[0].state State of origin point location
 * @param {string} args.params[0].city City of origin point location
 * @param {Array} args.params[0].show_stores_list Array of Store Names by which results should be filtered. Empty array
 * should be passed to return all stores.
 * @example
 * // var queryArgs = {
 * //     params : [{
 * //         fields : 'DOOR_ID, DOORNAME, STORE_HOURS, ADDRESS, ADDRESS2, STATE_OR_PROVINCE, CITY',
 * //         radius : 25,
 * //         zip    : '10014',
 * //         state  : 'NY',
 * //         city   : 'New York'
 * //     }],
 * //     callback : function() {
 * //          site.locator.ui.displayMap();
 * //          site.locator.ui.displayResultsTable();
 * //      }
 * // };
 */
site.locator.data.submitQuery = function(args) {
  var params  = args.params;
  var callbackFn = args.callback;

  // Can't be both intl and local:
  if (params[0].state && params[0].intlCountry) {
    generic.showErrors([{ text : site.locator.errors.localOrIntl }], site.locator.nodes.locatorErrors);
    _scrollPageOnError();
    return;
  }

  // Intl Search:
  else if (params[0].intlCountry) {
    if (!params[0].intlCity) {
      generic.showErrors([{text : site.locator.errors.missingCityIntl}], site.locator.nodes.locatorErrors);
      _scrollPageOnError();
      return;
    }
    params[0].country = params[0].intlCountry;
    params[0].city = params[0].intlCity;
    params[0].state = '';
  }

  // Local Search:
  else if (params[0].zip || params[0].state) {
    if (params[0].zip) {
      // Invalid zip (copied from PC js, this should maybe be handled server-side)
      var zipRegEx = new RegExp(/^[0-9]{4,5}$/);
      if (!(zipRegEx.test(params[0].zip))) {
        generic.showErrors([{ text : site.locator.errors.invalidZip }], site.locator.nodes.locatorErrors);
        _scrollPageOnError();
        return;
      }
      // If zip is set, don't use state & city
      params[0].state = '';
      params[0].city = '';
    }
    else if (!params[0].city) {
      // Missing City
      generic.showErrors([{ text : site.locator.errors.missingCityUS }], site.locator.nodes.locatorErrors);
      _scrollPageOnError();
      return;
    }
  }
  else if(!params[0].zip && !params[0].city){
      generic.showErrors([{ text : site.locator.errors.insufficientQueryData }], site.locator.nodes.locatorErrors);  
      _scrollPageOnError();
      return;
  }
  // Can't be neither intl nor local
  else {
    // This error is returned by the server.
  }
  site.locator.data.fetch({
    data: params,
    onSuccess: function(resultData, countersData) {
      if (!resultData || (typeof resultData.error != 'undefined' && resultData.error.length)) {
        // Reset store location results:
        $('.doors-results__inner').empty();
        site.locator.nodes.locatorWrapper.removeClass('has-filters expanded-filters show-all');
        site.locator.nodes.filters.removeClass('expanded');
        site.locator.nodes.resultsHeader.hide();
        site.locator.nodes.pager.hide();
        site.locator.nodes.pagerPages.empty();
        site.locator.nodes.dirResults.empty();
        site.locator.nodes.dirClosest.empty();
        site.locator.nodes.dirOriginInput.val('');
        site.locator.nodes.dirDestinationInput.val('');
        site.locator.nodes.dirDestinationInput.removeClass('filled-in');
        site.locator.nodes.dirOriginInput.removeClass('filled-in');
        site.locator.nodes.viewAllLink.removeClass('active');
        generic.showErrors([{ text : site.locator.errors.noLocationsFound }], site.locator.nodes.locatorErrors);
        _scrollPageOnError();
        //return;
      } else {
        generic.showErrors([], site.locator.nodes.locatorErrors);
      }

      resultData.maxDistance = parseFloat(args.params[0].radius);
      if (isNaN(resultData.maxDistance) ) {
        resultData.maxDistance = null;
      }

      if (enable_oab_locator_booking_functions) {
        for (var i = 0, len = countersData.length; i < len; i +=1) {
          var cData = countersData[i],
            res = resultData.results[cData.store_no];
          if (res) {
            res.APPT_BOOK_COUNTER_ID = cData.id;
          }
        }
      }

      site.locator.data.setData(resultData);
      if (typeof callbackFn === "function") {
        callbackFn();
      }
    },
    onFailure: function(jsonRpcResponse) {
      var errorObjectsArray = jsonRpcResponse.getMessages();
      // generic.showErrors([], site.locator.nodes.locatorErrors);
      generic.showErrors(errorObjectsArray, site.locator.nodes.locatorErrors);
      _scrollPageOnError();
      // if (params[0].intlSearch) {
      //   generic.showErrors([{text : site.locator.errors.missingCityIntl}], site.locator.nodes.locatorErrors);
      // }
      // else {
      //   generic.showErrors([{text : site.locator.errors.missingCityUS}], site.locator.nodes.locatorErrors);
      // }
    }
  });
 };
/*
 * Callback function that handles response from JSON-RPC request. It filters
 * and sorts the result data, then places the data in the global variable
 * site.locator.resultData.results
 */
site.locator.data.fetch = function (args) {
  generic.jsonrpc.fetch({
    method: 'locator.doorsandevents',
    params: args.data,
    onSuccess: function(r) {
      var resultData = r.getValue();

      if (enable_oab_locator_booking_functions) {
        generic.jsonrpc.fetch({
          method: "appointmentbooking.getauthtoken",
          onSuccess: function (rpc) {
            var token = rpc.getValue().auth_token;
            $.ajax(
              {
                url: 'https://' + window.location.hostname + '/_abapi/api/v1/counters',
                type: "GET",
                data: {token: token, lite: 1},
                success: function (counters) {
                  args.onSuccess(resultData, counters);
                },
                error: function (err) {
                  args.onSuccess(resultData, []);
                }
              }
            );
          },
          onError: function (rpc) {
            args.onSuccess(resultData, []);
          }
        });
      } else {
        args.onSuccess(resultData, []);
      }
    },
    onFailure: function (r) {
      args.onFailure(r);
    }
  });
};

/*
 * Callback function that handles response from JSON-RPC request. It filters
 * and sorts the result data, then places the data in the global variable
 * site.locator.resultData.results
 */
site.locator.data.setData = function(rawResultData) {

  site.locator.resultData = rawResultData;
  if (rawResultData.maxDistance) { // max distance exists
    var filteredResults = {};
    for (var d in rawResultData.results) {
      if (rawResultData.results[d].DISTANCE < rawResultData.maxDistance) {
        filteredResults[d] = rawResultData.results[d];
      }
    }
    site.locator.resultData.results = filteredResults;
  }

  // asc. sort by distance
  if (typeof site.locator.resultData.doors != 'undefined') {
    var sortedResults = {};
    var r = site.locator.resultData.results;
    site.locator.sortedDoorIds = site.locator.resultData.doors.sort(function(a, b) {
      return parseFloat(r[a].DISTANCE) - parseFloat(r[b].DISTANCE);
    });

    for (var i = 0; i < site.locator.sortedDoorIds.length && i < site.locator.maxResults; i++) {
      // Force the key to be a string, otherwise the browser just sorts numerically.
      // The key isn't important anyway:
      sortedResults['s' + site.locator.sortedDoorIds[i]] = site.locator.resultData.results[site.locator.sortedDoorIds[i]];

      // For testing display of hours:
      // sortedResults['s' + site.locator.sortedDoorIds[i]].STORE_HOURS = 'Mon - Fri: 9AM - 5PM<br />Sat: 10AM - 3PM<br />Sun: Closed';
    }
    site.locator.resultData.results = sortedResults;
  } else {
    $('.doors-results__inner').text( site.locator.errors.noLocationsFound );
  }
};

$(document).on('locator.submitSearchQuery', function(evt, param) {
  site.locator.data.submitQuery(param);
});

/*
 * This function helps to format the label next to checkbox by
 * adding and removing class and assigns the checked property of checbox
 */
site.locator.formatLabel = function(args) {
  args.element.next().removeClass(args.removeClass).addClass(args.addClass);
  if(args.checked == 1) {
    args.element.attr('checked', true);
  }
  else {
    args.element.removeAttr('checked');
  }
  args.element.next().parent().html(args.element.parent().html());
}

/*
 * It manages the checkAll and uncheckAll functions of All Stores checkbox
 */
site.locator.checkAll = function(element) {
  var checkAllIE = true;
  $(element).each(function() {
    if($(this).children('input[type=checkbox]').next().hasClass('checkedlabel')) {
      checkAllIE = false;
      return false;
    }
  });
  if( checkAllIE == true) {
    var args = { element: $('#store-name-filter-0'),
		 addClass: 'checkedlabel',
		 removeClass: 'notcheckedlabel',
		 checked: 1
	       };
    site.locator.formatLabel(args);
  }
}

site.locator.clearSelectedFilters = function(element) {
  $(element).each(function() {
    var storeCheckbox = $(this).children('input[type=checkbox]');
    var args = { element: storeCheckbox,
	         addClass: 'notcheckedlabel',
	         removeClass: 'checkedlabel',
	         checked: 0
	       };
    site.locator.formatLabel(args);
  });
  args = { element: $('#store-name-filter-0'),
	   addClass: 'checkedlabel',
	   removeClass: 'notcheckedlabel',
	   checked: 1
	 };
  site.locator.formatLabel(args);
}

site.locator.fixCheckbox = function() {
  var storeList = '.store-name-filters__inner ul.store-name-filters__list';
  var storeListItem = '.store-name-filters__inner ul.store-name-filters__list li.store-name-filters__item';
  $(storeList).on('click',  'li.store-name-filters__item', function(){
  $(this).children('input[type=checkbox]').click(function(e) {
    if($(this).attr('id') != 'store-name-filter-0') {
      e.stopImmediatePropagation();
      if($(this).next().hasClass('notcheckedlabel')) {
        var args = { element: $(this),
                     addClass: 'checkedlabel',
                     removeClass: 'notcheckedlabel',
                     checked: 1
                   };
        site.locator.formatLabel(args);
        args = { element: $('#store-name-filter-0'),
                addClass: 'notcheckedlabel',
                removeClass: 'checkedlabel',
                checked: 0
              };
        site.locator.formatLabel(args);
      }
      else {
        var args = { element: $(this),
                     addClass: 'notcheckedlabel',
                     removeClass: 'checkedlabel',
                     checked: 0
                   };
        site.locator.formatLabel(args);
        site.locator.checkAll(storeListItem);
      }
    }
    else {
      site.locator.clearSelectedFilters(storeListItem);
    }
  });
});
}

Drupal.behaviors.storeLocator = {
  attach: function(context) {
    site.locator.run(); // Load the store locator even if we don't yet have a location
    site.locator.util.getLocation();
    //IE8Fix: Format the label as checkbox in Filter by Stores List
    if (generic.env.isIE8) {
      site.locator.fixCheckbox();
    }

    function _tabState($trigger, wrapperClass, states) {
      var index = $trigger.index();
      for (var i = 0; i < states.length; i++) {
        states[i] = wrapperClass + '--' + states[i];
      }
      var classes = states.join(' ');

      $trigger.addClass('active').siblings().removeClass('active');
      $('.' + wrapperClass).removeClass( classes ).addClass( states[index] );
    }

    $('.local-search__option', context).on('click', function(e) {
      var states = [
        'stores',
        'directions'
      ];
      _tabState($(this), 'local-search__search-container', states);
	if($('.local-search').hasClass('directions')) {
			$('.local-search').removeClass('directions');
		 } else {
			$('.local-search').addClass('directions');
		 }
		  

      e.preventDefault();
    });

    $('.store-locator__nav-item', context).on('click', function(e) {
      var states = [
        'local-search',
        'intl-search',
        'trip-planner'
      ];

      _tabState($(this), 'store-locator', states);

      if (site.locator.map) {
        google.maps.event.trigger(site.locator.map,'resize');
        //site.locator.map.setCenter();
      }

      e.preventDefault();
    });

    // International search:
    var $select = $('.intl-search__menu-select', context);
    $('.intl-search__menu li > a', context).each(function() {
      generic.forms.select.addOption({
        menuNode: $select,
        label: $(this).text(),
        value: $(this).attr('href')
      });
    });
    Drupal.ELB.refreshSelectBoxes($select);
    $select.selectBox().on('change', function(e) {
      if ($(this).val()) {
        window.location = $(this).val();
      }
    });
  }
};

})(jQuery);
